import React, { useEffect, useState, useRef } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner } from 'reactstrap';
import JobCardGrid from './JobCardGrid';
import { useUser } from '../../hooks';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { Job } from '../../models/Job.interface';
import { useFirebaseDedup } from '../../hooks/useFirebaseDedup';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import ViewJobNotifications from "./ViewJobNotifications";

const AdminDashboard = () => {

    const [loading, setLoading] = useState(true);
    const { currentUserId, contractor } = useUser();
    const { dedupRequest } = useFirebaseDedup();
    const isMountedRef = useRef(true);

    useEffect(() => {
        document.title = "BidBro: Admin Dashboard";
      }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Test" pageTitle="Dashboards" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <h4 className="card-title mb-0">Test</h4>
                                </CardHeader>
                                <CardBody>
                                    <ViewJobNotifications />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default AdminDashboard;